import React from "react";
import LocaleContext from "../../state/contexts/LocaleContext";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,

} from "../../Styling/styledModal/styledModals";
import { messages } from './LogoutWarningModal.i18n'
import { BfButtonBlue } from "../../Styling/styledForm/styledBlueForm";


const LogoutWarningModal = (props) => {

    const locale = React.useContext(LocaleContext);
    const localeMessages = messages[locale]   

    return (

        <StyledModal centered show={true}>

            <StyledModalBody>
                <h4>{localeMessages["TS1M_Overskrift"]}</h4>
                <p>{localeMessages["TS1M_message"]}</p>
            </StyledModalBody>

            <StyledModalFooter>
                <BfButtonBlue onClick={props.refreshToken}>
                    {localeMessages["TS1M_Avbryt"]}
                </BfButtonBlue>
                {/* 
                <Button variant="secondary" onClick={props.closeLogoutWarning}>
                    {localeMessages["TS1M_Lukk"]}
                </Button>
                */}
            </StyledModalFooter>

        </StyledModal>
    );
};

export default LogoutWarningModal;